const knownEntryScripts = [
  "fertilizer-pdp-react.js",
  "bundle-pdp-react.js",
  "halm-pflegeset-react.js",
  "react-pdp.js",
];

const getThemeAssetBaseUrl = () => {
  const currentScript = document.currentScript as HTMLScriptElement | null;
  const scriptSrc =
    currentScript?.src ||
    knownEntryScripts
      .map(
        (entryScript) =>
          Array.from(document.scripts).find(
            (script) =>
              typeof script.src === "string" &&
              script.src.includes(entryScript),
          )?.src,
      )
      .find(Boolean);

  return scriptSrc ? new URL(".", scriptSrc).href : "/assets/";
};

const themeAssetBaseUrl = getThemeAssetBaseUrl();

export const getThemeAssetUrl = (fileName: string) =>
  new URL(fileName, new URL(themeAssetBaseUrl, window.location.href)).href;
